import { createSelector } from 'reselect';

const selectPeerCategories = (s) => s.peerCategories.items;
const selectPeerCategoriesInstruments = (s) => s.peerCategories.instruments;

export const selectPeerCategory = createSelector(
  (_, id) => id,
  selectPeerCategories,
  selectPeerCategoriesInstruments,
  (id, peers, instruments) => {
    const p = peers.find((c) => c.id === id);
    if (!p) return null;
    return { ...p, instruments: instruments[p.id] ?? [] };
  }
);
